export default __webpack_public_path__ + "static/media/coins.d6bcd717.svg";